export enum EVisualizacaoAgendamento {
    Dia = 1,
    Semana = 2,
    Mes = 3,
    Ano = 4
}
